import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../../../../components/Navbar';
import Footer from '../../../../../home/components/Footer';

export default function EVChargerPinner() {
  const nearbyAreas = [
    { name: 'Rickmansworth', slug: 'rickmansworth' },
    { name: 'Chorleywood', slug: 'chorleywood' },
    { name: 'Moor Park & Northwood', slug: 'moor-park-northwood' },
    { name: 'Croxley Green', slug: 'croxley-green' },
    { name: 'Bushey', slug: 'bushey' },
    { name: 'Abbots Langley', slug: 'abbots-langley' },
    { name: 'Harrow', slug: 'harrow' },
    { name: 'Ruislip', slug: 'ruislip' },
    { name: 'Stanmore', slug: 'stanmore' },
    { name: 'Edgware', slug: 'edgware' },
    { name: 'Mill Hill', slug: 'mill-hill' },
    { name: 'Radlett', slug: 'radlett' },
    { name: 'Borehamwood', slug: 'borehamwood' },
    { name: 'Elstree', slug: 'elstree' },
    { name: 'Potters Bar', slug: 'potters-bar' },
    { name: 'South Oxhey', slug: 'south-oxhey' },
  ];

  useEffect(() => {
    document.title = 'Pinner EV Charger Installation 020 3198 1818 | Beyond Electrical';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional EV charger installation in Pinner. 7kW, 22kW & solar-compatible chargers. OLEV-approved installers. Call 020 3198 1818 for a free quote today.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'EV charger installation Pinner, electric vehicle charger, home EV charging, 7kW charger, 22kW charger');
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://beyondelectrical.co.uk/services/installations/ev-charger/pinner');
    }

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": "https://beyondelectrical.co.uk/#business",
          "name": "Beyond Electrical - Pinner",
          "image": "https://beyondelectrical.co.uk/logo.png",
          "telephone": "020 3198 1818",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Pinner",
            "addressLocality": "Pinner",
            "addressRegion": "Greater London",
            "postalCode": "HA5",
            "addressCountry": "GB"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 51.5928,
            "longitude": -0.3817
          },
          "url": "https://beyondelectrical.co.uk/services/installations/ev-charger/pinner",
          "priceRange": "££",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "18:00"
            }
          ]
        },
        {
          "@type": "Service",
          "serviceType": "EV Charger Installation",
          "provider": {
            "@id": "https://beyondelectrical.co.uk/#business"
          },
          "areaServed": {
            "@type": "City",
            "name": "Pinner"
          },
          "description": "Professional EV charger installation services in Pinner including 7kW, 22kW and solar-compatible charging points for homes and businesses."
        }
      ]
    };

    const scriptTag = document.createElement('script');
    scriptTag.type = 'application/ld+json';
    scriptTag.text = JSON.stringify(schema);
    document.head.appendChild(scriptTag);

    return () => {
      document.head.removeChild(scriptTag);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#0A1628] to-[#0F2847] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          }}></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-[#FFD700] text-[#0A1628] px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-map-pin-line"></i>
              Pinner EV Charger Installation
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Professional EV Charger Installation in <span className="text-[#FFD700]">Pinner</span>
            </h1>
            
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Expert electric vehicle charging point installation for homes and businesses in Pinner. 
              OZEV-approved installers with fast, reliable service.
            </p>

            <div className="flex flex-wrap gap-4 justify-center">
              <a 
                href="tel:02031981818"
                className="inline-flex items-center gap-2 bg-[#FFD700] text-[#0A1628] px-8 py-4 rounded-lg font-semibold hover:bg-[#FFC700] transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Call 020 3198 1818
              </a>
              <a 
                href="/contact"
                className="inline-flex items-center gap-2 bg-white/10 text-white border-2 border-[#FFD700] px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap"
              >
                <i className="ri-mail-line text-xl"></i>
                Get Free Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <section className="py-12 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-[#0A1628] mb-1">OZEV</div>
              <div className="text-sm text-gray-600">Approved</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-time-line text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-[#0A1628] mb-1">Same Day</div>
              <div className="text-sm text-gray-600">Installation</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-calendar-check-line text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-[#0A1628] mb-1">3 Year</div>
              <div className="text-sm text-gray-600">Warranty</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-star-line text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-[#0A1628] mb-1">5 Star</div>
              <div className="text-sm text-gray-600">Rated</div>
            </div>
          </div>
        </div>
      </section>

      {/* Charger Types */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-4">
              EV Charger Options for Pinner
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose the perfect charging solution for your electric vehicle
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-[#FFD700] transition-all">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-home-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1628] mb-3">Home Chargers</h3>
              <div className="text-3xl font-bold text-[#FFD700] mb-4">7kW</div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Full charge overnight</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Smart app control</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">OZEV grant eligible</span>
                </li>
              </ul>
              <a href="tel:02031981818" className="block text-center bg-[#FFD700] text-[#0A1628] px-6 py-3 rounded-lg font-semibold hover:bg-[#FFC700] transition-all whitespace-nowrap">
                Get Quote
              </a>
            </div>

            <div className="bg-white rounded-xl p-8 border-2 border-[#FFD700] hover:border-[#FFD700] transition-all relative">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#FFD700] text-[#0A1628] px-4 py-1 rounded-full text-sm font-semibold whitespace-nowrap">
                Most Popular
              </div>
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-flashlight-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1628] mb-3">Fast Chargers</h3>
              <div className="text-3xl font-bold text-[#FFD700] mb-4">22kW</div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">3x faster charging</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Commercial grade</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Multiple vehicles</span>
                </li>
              </ul>
              <a href="tel:02031981818" className="block text-center bg-[#FFD700] text-[#0A1628] px-6 py-3 rounded-lg font-semibold hover:bg-[#FFC700] transition-all whitespace-nowrap">
                Get Quote
              </a>
            </div>

            <div className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-[#FFD700] transition-all">
              <div className="w-16 h-16 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-building-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1628] mb-3">Commercial</h3>
              <div className="text-3xl font-bold text-[#FFD700] mb-4">50kW+</div>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Rapid charging</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Payment systems</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FFD700] text-xl mt-0.5"></i>
                  <span className="text-gray-600">Fleet management</span>
                </li>
              </ul>
              <a href="tel:02031981818" className="block text-center bg-[#FFD700] text-[#0A1628] px-6 py-3 rounded-lg font-semibold hover:bg-[#FFC700] transition-all whitespace-nowrap">
                Get Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gradient-to-br from-[#0A1628] to-[#0F2847]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Why Choose Beyond Electrical for EV Charging?
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Pinner's trusted EV charger installation experts
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">OZEV Approved</h3>
              <p className="text-gray-300">
                Certified installers eligible for government grants and funding
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-user-star-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Expert Team</h3>
              <p className="text-gray-300">
                Fully qualified electricians with extensive EV charger experience
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-time-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Fast Installation</h3>
              <p className="text-gray-300">
                Most installations completed in a single day with minimal disruption
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-price-tag-3-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Competitive Pricing</h3>
              <p className="text-gray-300">
                Transparent quotes with no hidden costs or surprise charges
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-customer-service-2-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Ongoing Support</h3>
              <p className="text-gray-300">
                Comprehensive aftercare and maintenance services available
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/30">
              <div className="w-12 h-12 bg-[#FFD700] text-[#0A1628] rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-star-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">3-Year Warranty</h3>
              <p className="text-gray-300">
                All installations backed by comprehensive warranty coverage
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Installation Process */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Our Installation Process
          </h2>
          <div className="space-y-6">
            <div className="flex gap-6 items-start">
              <div className="w-12 h-12 bg-amber-500 text-white rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0">
                1
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Site Survey</h3>
                <p className="text-gray-600">
                  We visit your property in Pinner to assess your electrical system, parking area, and determine the best charger location.
                </p>
              </div>
            </div>

            <div className="flex gap-6 items-start">
              <div className="w-12 h-12 bg-amber-500 text-white rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0">
                2
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Quote & Planning</h3>
                <p className="text-gray-600">
                  Receive a detailed quote including equipment, installation, and any necessary electrical upgrades. We handle all DNO applications.
                </p>
              </div>
            </div>

            <div className="flex gap-6 items-start">
              <div className="w-12 h-12 bg-amber-500 text-white rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0">
                3
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Professional Installation</h3>
                <p className="text-gray-600">
                  Our OLEV-approved electricians install your charger to the highest standards, typically completed in 3-4 hours.
                </p>
              </div>
            </div>

            <div className="flex gap-6 items-start">
              <div className="w-12 h-12 bg-amber-500 text-white rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0">
                4
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Testing & Handover</h3>
                <p className="text-gray-600">
                  Complete testing, certification, and a full demonstration of your new EV charger. We'll show you how to use all features.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Benefits of Home EV Charging
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-pound-circle-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Save Money</h3>
              <p className="text-gray-600">
                Charge overnight on cheaper electricity rates. Up to 70% cheaper than public charging.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Convenience</h3>
              <p className="text-gray-600">
                Wake up to a fully charged car every morning. No more trips to petrol stations.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Eco-Friendly</h3>
              <p className="text-gray-600">
                Reduce your carbon footprint. Pair with solar panels for zero-emission charging.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-heart-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Add Value</h3>
              <p className="text-gray-600">
                Increase your property value. EV chargers are increasingly sought after by buyers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 px-4 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold mb-12 text-center">
            Why Choose Beyond Electrical in Pinner?
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="flex gap-4">
              <i className="ri-shield-check-line text-3xl text-amber-500 flex-shrink-0"></i>
              <div>
                <h3 className="text-xl font-bold mb-2">OLEV Approved</h3>
                <p className="text-gray-300">
                  Fully accredited installers eligible for government grants and incentives.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className="ri-tools-line text-3xl text-amber-500 flex-shrink-0"></i>
              <div>
                <h3 className="text-xl font-bold mb-2">Expert Installation</h3>
                <p className="text-gray-300">
                  Qualified electricians with extensive EV charger installation experience.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className="ri-customer-service-2-line text-3xl text-amber-500 flex-shrink-0"></i>
              <div>
                <h3 className="text-xl font-bold mb-2">Full Support</h3>
                <p className="text-gray-300">
                  From initial survey to aftercare, we're here to help every step of the way.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className="ri-price-tag-3-line text-3xl text-amber-500 flex-shrink-0"></i>
              <div>
                <h3 className="text-xl font-bold mb-2">Competitive Pricing</h3>
                <p className="text-gray-300">
                  Transparent quotes with no hidden costs. Quality installation at fair prices.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-amber-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Ready to Install Your EV Charger?
          </h2>
          <p className="text-xl text-white mb-8">
            Get a free quote for EV charger installation in Pinner today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:02031981818"
              className="inline-flex items-center gap-2 bg-white text-gray-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              020 3198 1818
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-gray-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap"
            >
              Request Free Quote
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Back Link */}
      <section className="py-8 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <Link
            to="/services/installations/ev-charger"
            className="inline-flex items-center gap-2 text-amber-600 hover:text-amber-700 font-semibold"
          >
            <i className="ri-arrow-left-line"></i>
            Back to EV Charger Services
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}